/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';
import * as moment from 'moment/moment';
import 'moment/locale/ja';

//先月
export const lastmonth = moment()
  .add(-1, 'month')
  .startOf('month')
  .format('YYYY-MM');

// 先々月
export const twoMonthsAgo = moment()
  .add(-2, 'month')
  .startOf('month')
  .format('YYYY-MM');

export const sectionSlice = createSlice({
  name: 'section',
  initialState: {
    section: '', //1 自社 2 競合
    kubun: 'direct',
    yearMonth: lastmonth,
    yearMonth2: twoMonthsAgo
  },
  reducers: {
    registerMy: (state) => {
      state.section = 1;
    },
    registerOther: (state) => {
      state.section = 2;
    },
    changeKubun: (state, action) => {
      state.kubun = action.payload;
    },
    resetKubunYearMonth: (state) => {
      return {
        ...state,
        kubun: 'direct',
        yearMonth: lastmonth
      };
    },
    changeYearMonth: (state, action) => {
      return {
        ...state,
        yearMonth: action.payload
      };
    },
    changeYearMonth2: (state, action) => {
      return {
        ...state,
        yearMonth2: action.payload
      };
    }
  }
});

export const {
  registerMy,
  registerOther,
  changeKubun,
  changeYearMonth,
  resetKubunYearMonth,
  changeYearMonth2
} = sectionSlice.actions;
export const currentsection = (state) => state.currentsection.section;
export const currentkubun = (state) => state.currentsection.kubun;
export const currentmonth = (state) => state.currentsection.yearMonth;
export const comparemonth = (state) => state.currentsection.yearMonth2;

export default sectionSlice.reducer;
